import React, { ReactElement } from 'react';
import { ApolloError } from '@apollo/client';
import { Modal } from '@odin-labs/components';
import { useJobsiteReinstateContractorMutation } from 'apollo/generated/client-operations';
import { getGraphQLError } from 'utils/error';
import { AlertService } from 'components/alertService';
import { CheckIcon } from 'components/icons';
import { ReinstateJobsiteContractorModalProps } from './types';

export function ReinstateJobsiteContractorModal(
  props: ReinstateJobsiteContractorModalProps,
): ReactElement {
  const {
    isOpen,
    closeModal,
    onClosed,
    jobsiteContractorId,
    jobsiteName,
    contractorName,
    workersCount,
    refetchQueries,
  } = props;

  const [jobsiteReinstateContractor, { loading }] =
    useJobsiteReinstateContractorMutation({
      fetchPolicy: 'no-cache',
      onCompleted: () => {
        closeModal();
        AlertService.alert(
          'success',
          'Success',
          'Successfully reinstated workers for the jobsite',
        );
      },
      onError: (responseError: ApolloError) => {
        AlertService.alert(
          'danger',
          'Something went wrong!',
          getGraphQLError(responseError),
        );
      },
      variables: { input: { jobsiteContractorId } },
      refetchQueries,
    });

  return (
    <Modal
      open={isOpen}
      setOpen={closeModal}
      afterLeave={onClosed}
      size="xs"
      title="Are you sure?"
      titleAlignment="center"
      text={`You are about to reinstate all of ${contractorName}'s workers who were previously offboarded from ${jobsiteName}. This will affect ${workersCount} workers and will take effect immediately. Are you sure you want to proceed?`}
      textAlignment="center"
      onAction={jobsiteReinstateContractor}
      actionText="Reinstate Workers"
      actionButtonTheme="danger"
      actionIcon={CheckIcon}
      actionButtonWithSpinner={loading}
    />
  );
}
